import styled from 'styled-components'

export const Tiles = styled.div<{
  $tile1theme: string
  $tile2theme: string
  $tile3theme: string
  $tile1Bg: string
  $tile2Bg: string
  $tile3Bg: string
}>`
  .new__area {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    color: ${({ theme }) => theme.webMktNewPalette.black};
    max-width: 1920px;
    margin: 0 auto;
    .mb-25 {
      margin-bottom: 25px;
    }
    .panelContainer {
      display: flex;
      flex-direction: row;
      overflow: hidden;
      margin-top: 16px;

      ${({ theme }) => theme.breakpoints.down('xs')} {
        flex-direction: column;
      }

      .leftPanel {
        width: calc(75% - 16px);
        box-sizing: border-box;
        position: relative;
        margin-right: 16px;
        height: 660px;
        box-sizing: border-box;
        overflow: hidden;
        cursor: pointer;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          width: 100%;
          margin-right: 0;
          margin-bottom: 16px;
          height: 600px;
        }

        ${({ theme }) => theme.breakpoints.down('xs')} {
          height: 560px;
          margin-bottom: 16px;
        }

        h2 {
          font-size: 44px;
          line-height: 48px;
          letter-spacing: -2px;
          font-weight: 600;
          color: ${({ theme }) => theme.webMktNewPalette.black};
          width: 68%;

          ${({ theme }) => theme.breakpoints.down('md')} {
            width: 100%;
          }

          ${({ theme }) => theme.breakpoints.down('sm')} {
            width: 85%;
            font-size: 40px;
            line-height: 44px;
          }

          ${({ theme }) => theme.breakpoints.down('xs')} {
            width: 100%;
            font-size: 28px;
            line-height: 36px;
          }
        }
        p {
          font-size: 20px;
          line-height: 32px;
          font-weight: 400;
          letter-spacing: -0.5px;
          color: ${({ theme }) => theme.webMktNewPalette.black};
          margin: 16px 0;
        }
        .CTA {
          ${({ theme }) => theme.breakpoints.down('xs')} {
            bottom: 24px;
            position: absolute;
          }
          span:not(:empty) {
            margin-right: 16px;
          }
          .CTA__Arrow-Container {
            margin-left: 0;
          }
        }
        .item__box {
          @media screen and (min-width: 1025px) {
            :hover {
              .item__bg {
                filter: opacity(1);
                transition: all 1s;
                -ms-transform: scale(1.1);
                -moz-transform: scale(1.1);
                -webkit-transform: scale(1.1);
                -o-transform: scale(1.1);
                transform: scale(1.1);
              }
            }
          }

          ${({ theme }) => theme.breakpoints.down('xs')} {
            height: 100%;
          }

          .contentPart {
            padding: 48px 40px;
            position: relative;
            cursor: pointer;

            ${({ theme }) => theme.breakpoints.down('xs')} {
              padding: 24px 16px;
              height: calc(100% - 48px);
            }
          }
        }
        .primary.dark {
          h2 {
            color: ${({ theme }) => theme.webMktNewPalette.white};
          }
          p {
            color: ${({ theme }) => theme.webMktNewPalette.white};
          }
        }
      }
      .item__bg {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: all 1s ease 0s;
        filter: opacity(0.8);
      }
      .item__bg.dark.primary1 {
        background: url(${props => props.$tile1Bg});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .item__bg.light.primary1 {
        background: url(${props => props.$tile1Bg});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .item__bg.dark.secondary1 {
        background: url(${props => props.$tile2Bg});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .item__bg.light.secondary1 {
        background: url(${props => props.$tile2Bg});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .item__bg.dark.secondary2 {
        background: url(${props => props.$tile3Bg}) 50%;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .item__bg.light.secondary2 {
        background: url(${props => props.$tile3Bg});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }

      .rightPanel {
        background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
        display: flex;
        flex-direction: column;
        width: 25%;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          width: 100%;
          flex-direction: row;
        }

        ${({ theme }) => theme.breakpoints.down('xs')} {
          flex-direction: column;
        }

        .CTA {
          bottom: 24px;
          position: absolute;
          ${({ theme }) => theme.breakpoints.down('xs')} {
            bottom: 16px;
          }
          .CTA__Arrow-Container {
            margin-left: 0;
          }
          span:not(:empty) {
            margin-right: 16px;
          }
        }

        h2 {
          font-size: 20px;
          line-height: 24px;
          letter-spacing: -1px;
          font-weight: 600;
          color: ${({ theme }) => theme.webMktNewPalette.black};

          ${({ theme }) => theme.breakpoints.down('xs')} {
            font-size: 18px;
            letter-spacing: normal;
          }
        }

        .secondary {
          ${({ theme }) => theme.breakpoints.down('xs')} {
            width: 50%;
            margin-right: 8px;
          }

          ${({ theme }) => theme.breakpoints.down('xs')} {
            margin-right: 0px;
            width: 100%;
          }
        }
        .secondary.dark {
          h2 {
            color: ${({ theme }) => theme.webMktNewPalette.white};
          }
          p {
            color: ${({ theme }) => theme.webMktNewPalette.white};
          }
        }

        .secondary:last-child {
          ${({ theme }) => theme.breakpoints.down('xs')} {
            margin-right: 0;
            margin-left: 8px;
          }
          ${({ theme }) => theme.breakpoints.down('xs')} {
            margin-left: 0px;
          }
        }

        .secondary:first-child {
          margin-bottom: 16px;
          ${({ theme }) => theme.breakpoints.down('xs')} {
            margin-bottom: 0;
          }
          ${({ theme }) => theme.breakpoints.down('xs')} {
            margin-bottom: 16px;
          }
        }
        .item__box {
          position: relative;
          height: 50%;
          overflow: hidden;
          cursor: pointer;
          @media screen and (min-width: 1025px) {
            :hover {
              .item__bg {
                filter: opacity(1);
                transition: all 1s;
                -ms-transform: scale(1.1);
                -moz-transform: scale(1.1);
                -webkit-transform: scale(1.1);
                -o-transform: scale(1.1);
                transform: scale(1.1);
              }
            }
          }
          .contentPart {
            padding: 24px;
            position: relative;
            height: 100%;
            box-sizing: border-box;

            ${({ theme }) => theme.breakpoints.down('xs')} {
              height: 376px;
              padding: 16px;
            }

            ${({ theme }) => theme.breakpoints.down('xs')} {
              height: 360px;
            }
          }
        }
      }
    }
  }
`
